<div class="overlay" *ngIf="isLoading">
    <div class="spinner-container">
        <div class="spin"></div>
    </div>
</div>